module.exports = __webpack_public_path__ + "img/logo-mercedespay.1bf9a849.png";